export const businessFields = [
    [
      'strFeeSchedNm', 'strFeeComp', 'strFeeAmt', 'dtEffStartDate', 'dtEffEndDate', 'strStatus',
      'strExamCd', 'strExamName', 'strPassCd', 'strTestType', 'strRuleName', 'strRuleDesc', 'intValue',
      'strUnit', 'strAppliesTo', 'strLastModifiedByFullName', 'dtUpdatedDate', 'strAppPath', 'strAppType', 'intBgCheckReq',
      'strLicenseType', 'strCredType', 'intLicDuration', 'strExpDateRule'
    ],
    [
      'strUnit', 'intValue', 'strRuleName', 'strAppliesTo', 'strLastModifiedByFullName', 'dtUpdatedDate', 'dtUpdateddate', 'strDescription'
    ],
];